import { Component, computed, DestroyRef, ElementRef, Input, OnInit, effect, Inject, inject, Signal, viewChild, TemplateRef } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputGroupModule } from 'primeng/inputgroup';
import { MenubarModule } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';
import { ProgressBarModule } from 'primeng/progressbar';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { TicketsComponent } from '../tickets/tickets.component';
import { SponsorsComponent } from '../sponsors/sponsors.component';
import { Router, RouterModule } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule, DatePipe } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ISponsorCategories } from '../../../models/ISponsorCategories';
import { DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ITicket } from '../../../models/ITicket';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ISponsor } from '../../../models/ISponsor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCreditCard, faHeart, faShoppingBag, faTicket } from '@fortawesome/free-solid-svg-icons';
import { AbsoluteMediaUriService } from '../../../services/absolute-media-uri.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuthService, LOGIN_TYPE_COMPLETE_REGISTRATION, LOGIN_TYPE_PASSWORD_RESET, LOGIN_TYPE_REGISTER, LOGIN_TYPE_TOPBAR } from '../../../services/authentication/auth.service';
import { AuctionHomepageLiveEventComponent } from "./sections/auction-homepage-live-event/auction-homepage-live-event.component";
import { FormsModule } from '@angular/forms';
import { AuctionHomepageFeaturedItemsComponent } from './sections/auction-homepage-featured-items/auction-homepage-featured-items.component';
import { AuctionHomepageFirstTierSponsorsComponent } from './sections/auction-homepage-first-tier-sponsors/auction-homepage-first-tier-sponsors.component';
import { AuctionHomepageTopItemsComponent } from "./sections/auction-homepage-top-items/auction-homepage-top-items.component";
import { AuctionHomepageTopBiddersComponent } from "./sections/auction-homepage-top-bidders/auction-homepage-top-bidders.component";
import { ScrollTop } from 'primeng/scrolltop';
import { SearchBarComponent } from "../items/search-bar/search-bar.component";
import { IHomePage } from '../../../models/IHomePage';
import { ThemeService } from '../../../services/theme.service';
import { PreviewService } from '../../../services/preview.service';
import { CookiesDisabledBannerComponent } from "../../cookies-disabled-banner/cookies-disabled-banner.component";

export const HOMEPAGE_ONLINE_LIVE_EVENT = "HOMEPAGE_ONLINE_LIVE_EVENT";
export const HOMEPAGE_TICKET_ONLY = "HOMEPAGE_TICKET_ONLY";
export const HOMEPAGE_ONLINE_ONLY = "HOMEPAGE_ONLINE_ONLY";

@Component({
  selector: 'app-auction-homepage',
  imports: [
    AvatarModule,
    ButtonModule,
    CardModule,
    InputGroupModule,
    InputGroupAddonModule,
    MenubarModule,
    ProgressBarModule,
    HeaderComponent,
    FooterComponent,
    TicketsComponent,
    SponsorsComponent,
    RouterModule,
    DynamicDialogModule,
    CommonModule,
    ScrollTop,
    FontAwesomeModule,
    ProgressSpinnerModule,
    AuctionHomepageLiveEventComponent,
    FormsModule,
    AuctionHomepageFeaturedItemsComponent,
    AuctionHomepageFirstTierSponsorsComponent,
    AuctionHomepageTopItemsComponent,
    AuctionHomepageTopBiddersComponent,
    SearchBarComponent,
    CookiesDisabledBannerComponent,
],
  templateUrl: './auction-homepage.component.html',
  providers: [DatePipe, DynamicDialogRef],
  styleUrl: './auction-homepage.component.scss'
})
export class AuctionHomepageComponent implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  private readonly apiService = inject(ApiService)
  private readonly themeService = inject(ThemeService);
  private readonly previewService = inject(PreviewService);
  protected readonly isPreview = this.previewService.isPreview;
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly destroyRef = inject(DestroyRef);

  protected icons = {
    faShoppingBag: faShoppingBag,
    faCreditCard: faCreditCard,
    faTicket: faTicket,
    faHeart: faHeart,
  }
  protected readonly homepageOnlineLiveEvent = HOMEPAGE_ONLINE_LIVE_EVENT;
  protected readonly homepageTicketOnly = HOMEPAGE_TICKET_ONLY;
  protected readonly homepageOnlineOnly = HOMEPAGE_ONLINE_ONLY;
  isAuthenticated = this.oidcSecurityService.authenticated;

  @Input() id!: number;
  @Input() passwordResetToken?: string;
  @Input() registrationToken?: string;


  heroDonateNowButtonTemplate = viewChild.required('heroDonateNowButton', { read: TemplateRef });
  heroItemsButtonTemplate = viewChild.required('heroItemsButton', { read: TemplateRef });
  heroTicketsButtonTemplate = viewChild.required('heroTicketsButton', { read: TemplateRef });

  items: MenuItem[] = [{ label: "Home", icon: "pi pi-home" }, { label: "Favorites", icon: "pi pi-bookmark" }];
  titleColor: String = "text-white";

  imageBanner: string = '';
  ticketsList: ITicket[] = [];
  language = 'en';
  country = 'US';


  //sponsors
  sponsorCategories: ISponsorCategories[] = [];

  // scroll
  showUpButton = false;
  showDownButton = false;


  homePageData = this.apiService.homePageSignal;
  auctionConfigSignal = this.apiService.auctionConfigSignal;

  withValue: IHomePage | null = null;

  safecallToActionTextHtml = computed(() => this.sanitizeHtmlText(this.homePageData()?.callToActionText || ''));
  safecallToActionTitleHtml = computed(() => this.sanitizeHtmlText(this.homePageData()?.callToActionTitle || ''));
  safeTicketHeadlineHtml = computed(() => this.sanitizeHtmlText(this.homePageData()?.ticketsHeadline || ''));

  isLoading = this.apiService.isLoadingEvenPage;

  protected isTicketFocused = computed(() => {
    let homePageData = this.homePageData();
    if (homePageData != null) {
      return homePageData.isTicketFocusedHomepageEnabled;
    }
    return false;
  });

  protected showBecomeASponsorSection = computed(() => {
    let homePageData = this.homePageData();
    let showSection = false;
    if (homePageData != null) {
      if (homePageData.callOutBoxTitle != null) {
        showSection = showSection || homePageData.callOutBoxTitle.length > 0;
      }
      if (homePageData.callOutBoxText != null) {
        showSection = showSection || homePageData.callOutBoxText.length > 0;
      }
      if (homePageData.featuredSponsors != null && homePageData.featuredSponsors.becomeASponsorEnabled != null) {
        showSection = showSection || homePageData.featuredSponsors.becomeASponsorEnabled;
      }
    }
    showSection = showSection || this.featuredSponsors().length > 0;
    return showSection;
  });

  protected showHeroImageText = computed(() => {
    let homePageData = this.homePageData();
    if (homePageData != null) {
      if (homePageData.heroImageText != null) {
        return homePageData.heroImageText.length > 0;
      }
    }
    return false;
  });

  protected showHeroImageSubText = computed(() => {
    let homePageData = this.homePageData();
    if (homePageData != null) {
      if (homePageData.heroImageSubText != null) {
        return homePageData.heroImageSubText.length > 0;
      }
    }
    return false;
  });

  protected heroImageText = computed(() => this.sanitizeHtmlText(this.homePageData()?.heroImageText || ''));

  protected heroImageSubText = computed(() => this.sanitizeHtmlText(this.homePageData()?.heroImageSubText || ''));

  protected customTicketSaleLink = computed(() => this.homePageData()?.customTicketSaleLink || '');

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {

    effect(() => {

      this.withValue = this.homePageData();

      if (this.withValue && isPlatformBrowser(this.platformId) && !this.previewService.isPreview) {
        localStorage.setItem('homePageData', JSON.stringify(this.withValue));
      }

      //banner image
      this.imageBanner = this.withValue?.heroImageUrl
        ? this.withValue.heroImageUrl
        : '';
    });

    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId) && this.previewService.isPreview) {
      this.disableInteractiveElements();
    }
    if (isPlatformBrowser(this.platformId)) {
  this.themeService.setPreset('bfg'); 
  this.themeService.customizeAuctionTheme(this.id);
}
    const endpoint = 'auctions';
    this.apiService.getAuctionHomePageData(endpoint, this.id);
    if (this.passwordResetToken != undefined && this.passwordResetToken !== "") {
      this.openPasswordResetModal(this.passwordResetToken);
    } else if (this.registrationToken != undefined && this.registrationToken !== "") {
      this.openCompleteRegistrationModal(this.registrationToken);
    }

    if (typeof window !== 'undefined' && this.id > 0) {
      this.getAuctionConfig();
    }
  }


  protected eventType = computed(() => {

    switch (this.homePageData()?.eventType) {
      case "ONLINE_ONLY":
        return HOMEPAGE_ONLINE_ONLY;
      case "ONLINE_TO_LIVE_BID_SHEETS":
      case "ONLINE_TO_LIVE_MOBILE":
        return HOMEPAGE_ONLINE_LIVE_EVENT;
      case "LIVE_ONLY":
      case "TICKET_ONLY":
        return HOMEPAGE_TICKET_ONLY;
      case "ONLINE_TO_LIVESTREAM":
      case "LIVESTREAM_WITH_LIVE":
      case "LIVESTREAM_ONLY":
      case "OTHER":
      default:
        return "";
    }
  });

  protected heroButton1: Signal<TemplateRef<any> | null> = computed(() => {
    const homePageData = this.homePageData();
    if (homePageData != null) {
      const heroButton = homePageData.heroButton1;
      return this.getHeroButtonTemplate(heroButton, this.isTicketFocused());
    }
    return null;
  });

  protected heroButton2: Signal<TemplateRef<any> | null> = computed(() => {
    const homePageData = this.homePageData();
    if (homePageData != null) {
      const heroButton = homePageData.heroButton2;
      return this.getHeroButtonTemplate(heroButton, this.isTicketFocused());
    }
    return null;
  });

  protected shouldDisplayViewAllItemsButton: Signal<boolean> = computed(() => {
    const homePageData = this.homePageData();
    if (homePageData == null) {
      return false
    };
    const eventType = this.eventType();
    const isOnlineEventType = eventType === this.homepageOnlineLiveEvent || eventType === this.homepageOnlineOnly;
    return isOnlineEventType && homePageData.showViewAllItemsButton && !this.isTicketFocused();
  });

  /**
   * Only the homepage has preview data, so nothing on it may navigate or open a modal.
   * Capture-phase listeners on the component stop links, buttons and the search bar before
   * their own handlers run. The header and footer are not strictly enforced.
   */
  private disableInteractiveElements() {
    const host = this.elementRef.nativeElement;
    const block = (event: Event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const onClick = (event: Event) => {
      if ((event.target as Element | null)?.closest('a, button, [routerLink], [role="button"]')) {
        block(event);
      }
    };
    // the search bar navigates on Enter, without a click
    const onKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && (event.target as Element | null)?.closest('input, a, button')) {
        block(event);
      }
    };

    host.addEventListener('click', onClick, true);
    host.addEventListener('keydown', onKeydown, true);
    host.addEventListener('submit', block, true);
    document.body.classList.add('preview-mode');

    this.destroyRef.onDestroy(() => {
      host.removeEventListener('click', onClick, true);
      host.removeEventListener('keydown', onKeydown, true);
      host.removeEventListener('submit', block, true);
      document.body.classList.remove('preview-mode');
    });
  }

  protected openLoginModal() {
    this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, function () { }, this.id);
  }

  protected openRegisterModal() {
    this.authService.openLoginModal(LOGIN_TYPE_REGISTER, function () { }, this.id);
  }

  protected openPasswordResetModal(passwordResetToken: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.authService.openLoginModal(LOGIN_TYPE_PASSWORD_RESET, () => { }, this.id, () => { }, passwordResetToken);
    }
  }

  protected openCompleteRegistrationModal(registrationToken: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.authService.openLoginModal(LOGIN_TYPE_COMPLETE_REGISTRATION, () => { }, this.id, () => { }, registrationToken);
    }
  }

  //Converts raw HTML string into rich text
  sanitizeHtmlText(content: string | undefined): SafeHtml {
    if (content != undefined && typeof window !== 'undefined' && typeof document !== 'undefined') {
      const txt = document.createElement('textarea');
      txt.innerHTML = content;
      const decodedContent = txt.value;
      return decodedContent ? this.sanitizer.bypassSecurityTrustHtml(decodedContent) : '';
    }
    return '';
  }

  protected featuredSponsors: Signal<ISponsor[]> = computed(() => {
    let homePageData = this.homePageData();
    if (homePageData != null) {
      return homePageData.featuredSponsors.sponsors;
    }
    return [];
  });

  protected hasMainArticleImage: Signal<Boolean> = computed(() => {
    let homePageData = this.homePageData();
    if (homePageData != null && homePageData.callToActionImageUrl != null) {
      return homePageData.callToActionImageUrl !== "";
    }
    return false;
  });

  protected isClosed: Signal<Boolean> = computed(() => {
    let configData = this.auctionConfigSignal();
    let homePageData = this.homePageData();
    if (configData == null || homePageData == null) {
      return true;
    }
    let offset = 1000 * 60 * 60 * 24 * 15 // 15 days;
    let comparisonDate = new Date(new Date().getTime() - offset);
    switch (homePageData.eventType) {
      case "ONLINE_ONLY":
      case "ONLINE_TO_LIVESTREAM":
      case "LIVESTREAM_ONLY":
        return comparisonDate > new Date(configData.onlineCloseDate);
      case "ONLINE_TO_LIVE_BID_SHEETS":
      case "ONLINE_TO_LIVE_MOBILE":
      case "LIVE_ONLY":
      case "TICKET_ONLY":
      case "LIVESTREAM_WITH_LIVE":
        if (configData.liveEventCloseDate == undefined) {
          return true;
        }
        return comparisonDate > new Date(configData.liveEventCloseDate);
      case "OTHER":
      default:
        return true;
    }
  });

  protected getBecomeASponsorUrl(): string {
    return this.absoluteMediaUriService.getAbsoluteMediaUri("/auction/communicate/becomesponsor.action?auctionId=" + this.id);
  }

  protected getSafeUri(uri: string | undefined | null): SafeResourceUrl {
    if (uri != undefined && uri != null) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(uri)
    }
    return "";
  }

  private getHeroButtonTemplate(heroButton: string | null, isTicketFocused: boolean) {
    if (heroButton != null && heroButton.length > 0) {
      switch (heroButton) {
        case "Donate Now":
          if (this.isClosed()) {
            return null;
          }
          return this.heroDonateNowButtonTemplate();
        case "Items":
          if (!isTicketFocused) {
            return this.heroItemsButtonTemplate();
          }
          break;
        case "Tickets":
          return this.heroTicketsButtonTemplate();
      }
    }
    return null;
  }

  getAuctionConfig() {
    this.apiService.getAuctionConfig(this.id).subscribe();
  }






}
